import React from 'react'

const NotFound = () => {
  React?.useEffect(() => {
    window.analytics.track('Page not found')
  }, [])

  return (
    <div style={{ textAlign: 'center' }}>
      <span
        style={{ fontSize: '100px' }}
        role='img'
        aria-label='sad face emoji'
      >
        😧
      </span>
      <h2>Oops! Nothing to see here.</h2>
    </div>
  )
}

export default NotFound
